import React from 'react';

import ResetPasswordBlock from '../../components/UI/ResetPasswordBlock';

const ResetPasswordPage = () => {
  return <ResetPasswordBlock />;
};

export default ResetPasswordPage;
